import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "157fc89d-fd52-41b4-aec6-5cb917824951",
  title: "Hansons Advanced Half Marathon",
  raceType: "Half Marathon",
  units: "miles",
  workouts: [
    { description: "Rest or Cross-Train", totalDistance: 0 },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "3 miles Easy",
      totalDistance: 3,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n12x400m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n8x600m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description: "5 milesEasy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "4 miles Easy 5",
      totalDistance: 4,
    },
    {
      description: "6 miles Easy 5",
      totalDistance: 6,
    },
    {
      description: "8 miles Easy 5",
      totalDistance: 8,
    },
    {
      description: "4 miles Easy",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1k @ 5k-10k pace w. 600m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1,200m @ 5k-10k pace w. 600m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "6 miles Easy 6",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy 6",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n3x1 miles @ 5k-10k pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "6 milesEasy",
      totalDistance: 6,
    },
    {
      description: "5 milesEasy",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1k @ 5k-10k pace w. 600m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n12x400m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ 10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ 10k pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "14 miles Long Run",
      totalDistance: 14,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ 10k pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n2x3 miles @ 10k pace w. 1 miles jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n7 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "14 miles Long Run",
      totalDistance: 14,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ 10k pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n7 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ 10k pace w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n7 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "14 miles Long Run",
      totalDistance: 14,
    },
    {
      description: "7 miles Easy",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ 10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "8 miles Easy",
      totalDistance: 8,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "6 miles Easy",
      totalDistance: 6,
    },
    {
      description: "5 miles Easy",
      totalDistance: 5,
    },
    {
      description: "3 miles Shakeout Run",
      totalDistance: 3,
    },
    { description: "Race Day!", totalDistance: 13.1 },
  ],
} as BuiltInPlan;
